import gql from 'graphql-tag';

// Saved on change, not with the settings form: the PHP publisher gets that form's object and never reads this column.
export default gql`
  mutation setProjectDesignProfile($projectId: Int!, $id: Int) {
    update_projects_by_pk(pk_columns: { project_id: $projectId }, _set: { design_profile_id: $id }) { project_id }
  }
`;
